import React, { useMemo } from "react";
import usePluginEntities from "hooks/usePluginEntities";
import GeneralEventSideBar from "components/events/ReplaySearchSidebar/GeneralEventSideBar";
const ReplaySearchSidebar = ({ alertId, definitionId = void 0 }) => {
  const sideBarDetailsPlugin = usePluginEntities("views.components.eventReplay.sideBarDetails");
  const isEventDefinition = !alertId && !!definitionId;
  const EventDefSideBar = useMemo(() => {
    const sideBarDetails = sideBarDetailsPlugin[0];
    const hasPlugin = typeof (sideBarDetails == null ? void 0 : sideBarDetails.useCondition) === "function" ? sideBarDetails.useCondition() : true;
    if (hasPlugin && (sideBarDetails == null ? void 0 : sideBarDetails.eventDefinitionComponent)) return sideBarDetails.eventDefinitionComponent;
    return null;
  }, [sideBarDetailsPlugin]);
  const EventSideBarDetails = useMemo(() => {
    const sideBarDetails = sideBarDetailsPlugin[0];
    const hasPlugin = typeof (sideBarDetails == null ? void 0 : sideBarDetails.useCondition) === "function" ? sideBarDetails.useCondition() : true;
    if (hasPlugin && !!(sideBarDetails == null ? void 0 : sideBarDetails.component)) return sideBarDetails.component;
    return GeneralEventSideBar;
  }, [sideBarDetailsPlugin]);
  if (isEventDefinition && EventDefSideBar) {
    return /* @__PURE__ */ React.createElement(EventDefSideBar, { definitionId });
  }
  return /* @__PURE__ */ React.createElement(EventSideBarDetails, { alertId, definitionId });
};
export default ReplaySearchSidebar;
